<template>
  <div class="rounded-[10px] bg-[#0c1116] p-3" data-testid="summary-selected-session">
    <h3 v-if="title" class="text-[17px] font-semibold text-white mb-2">{{ title }}</h3>
    <div class="text-[10px] uppercase text-white/55">{{ translate('ai_summary_selected_session', 'Selected session') }}</div>
    <div class="text-[13px] font-semibold text-white mt-1">{{ transcript.title }}</div>
    <div class="text-[11px] text-white/75 mt-1">{{ formatSessionRangeLabel(transcript.timestamp, transcript.duration_minutes) }}</div>
    <slot />
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import { translate } from '@/composables/useCaptionSettings';
import { formatSessionRangeLabel } from '@/utils/transcript-date';

defineProps({
  transcript: { type: Object, required: true },
  title: { type: String, default: '' },
});
</script>
